export function customizeCellFunction(cell, data) {

    let ActivityIcons = {
        iconStyles: {
            solid: { name: 'solid', className: 'fa' },
            regular: { name: 'regular', className: 'far' },
            light: { name: 'light', className: 'fal' }
        },

        iconAnimations: {
            none: { name: 'none', className: '' },
            spin: { name: 'spin', className: 'spin' },
            pulse: { name: 'pulse', className: 'pulse' }
        },
    };

    let getIcon = (iconSrc) => {

        if (iconSrc) {
            var icon = iconSrc.split(';');
            if (icon.length > 2) {
                return '' + (icon[2] && ActivityIcons.iconStyles[icon[2]] ? ActivityIcons.iconStyles[icon[2]].className : ActivityIcons.iconStyles[ActivityIcons.iconStyles.solid.name].className)
                    + ' fa-' + (icon[0])
                    + ' fa-' + (icon.length === 4 ? ActivityIcons.iconAnimations[icon[3]].className : ActivityIcons.iconAnimations.none.className);

            }
        }

        return '';
    }

    if (data.hierarchy && data.hierarchy.caption === 'Special Activity Icon') {
        if (data.label) {
            var icon = data.label.split(';');
            if (icon.length > 2) {
                cell.tag = 'div';
                cell.text = '<i class="' + getIcon(data.label) + '"> </i>';
                cell.style['text-align'] = 'center';
                cell.style['font-family'] = '&quot;Font Awesome 5 Pro&quot;';
                cell.style['color'] = icon[1];
                cell.style['font-weight'] = icon[2] && icon[2] === 'light' ? '300' : (icon[2] && icon[2] === 'regular' ? '400' : '900');
            }
        }
    }
}